// Карточка предупреждения: род по-русски, номер, сроки и текст оригинала.
//
// Текст не переводится и не пересказывается: сроки и координаты в нём —
// то, по чему капитан сверяется с NAVTEX, и пересказ их исказил бы.

import type { NavwarnFull } from '../api'
import { formatDayTime, useLang, useT } from '../i18n'
import { navwarnColor, navwarnKindKey, navwarnTitle } from '../map/navwarn'

export function NavwarnCard({ data, onClose }: { data: NavwarnFull; onClose: () => void }) {
  const t = useT()
  const { lang } = useLang()
  return (
    <div className="pointer-events-auto flex max-h-[calc(100vh-6rem)] w-[380px] flex-col rounded-xl border border-hull bg-abyss/95 p-3 text-[12px] shadow-console backdrop-blur">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="flex items-center gap-2 font-medium text-foam">
            <span aria-hidden className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: navwarnColor(data.kind) }} />
            <span>{t(navwarnKindKey(data.kind))}</span>
          </div>
          <div className="mt-0.5 text-mist">{navwarnTitle(data)} · {data.regions.join(' · ')}</div>
        </div>
        <button type="button" onClick={onClose} aria-label={t('navwarn.close')} className="text-faint hover:text-foam">
          ✕
        </button>
      </div>
      <dl className="mt-2 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-mist">
        <dt className="text-faint">{t('navwarn.issued')}</dt>
        <dd className="tnum">{formatDayTime(lang, data.issued)}</dd>
        <dt className="text-faint">{data.gone ? t('navwarn.gone') : t('navwarn.inForce')}</dt>
        <dd className="tnum">{data.gone ? formatDayTime(lang, data.gone) : '✓'}</dd>
      </dl>
      {data.has_coords && !data.shapes_parsed && (
        <p className="mt-2 text-[11px] text-amber-400">{t('navwarn.noShapes')}</p>
      )}
      <div className="mt-2 text-[10px] uppercase tracking-wide text-faint">{t('navwarn.original')}</div>
      <pre className="mt-1 min-h-0 flex-1 overflow-auto whitespace-pre-wrap rounded bg-deep p-2 font-mono text-[11px] leading-snug text-foam">
        {data.text}
      </pre>
    </div>
  )
}
